import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RdsDataAccessPolicyAccessRequirement } from './access-requirement-data-access-policy.component';
import { RdsIsDataUsageAgreementPipeModule } from '../core/pipes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    RdsIsDataUsageAgreementPipeModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
  ],
  exports: [RdsDataAccessPolicyAccessRequirement],
  declarations: [RdsDataAccessPolicyAccessRequirement],
})
export class RdsDataAccessPolicyAccessRequirementModule {}
